import { createMuiTheme } from '@material-ui/core/styles'
import { CSSProperties } from 'react'

const primaryColor = "#081036"
const secondaryColor = "#FF0000"
const textColor = "#081036"

const themeMain = createMuiTheme({
    shape: {
        borderRadius: 0
    },
    palette: {
        primary: {
            main: primaryColor,
            contrastText: '#fff'
        },
        secondary: {
            main: secondaryColor,
            contrastText: '#fff'
        },
        text: {
            primary: textColor,
            secondary: textColor,
            disabled: textColor,
            hint: textColor,
        }
    },
    typography: {
        fontFamily: 'Poppins',
        htmlFontSize: 16,
        //useNextVariants : true,
        button: {
            fontFamily: 'Poppins SemiBold',
            fontSize: '14px',
            color: textColor,
        },
        h1: {
            fontSize: '3rem',
            letterSpacing: '4px',
            lineHeight: '73px',
            color: textColor,
        },
        h2: {
            fontSize: '1.3rem',
            letterSpacing: '2.8px',
            lineHeight: '31px',
            color: textColor,
        },
        h3: {
            fontFamily: 'Poppins SemiBold',
            fontSize: '1.125rem',
            lineHeight: '27px',
            color: textColor,
        },
        h4: {
            fontFamily: 'Poppins SemiBold',
            fontSize: '0.875rem',
            lineHeight: '21px',
            color: textColor,
        },
        h5: { //LINKS
            fontFamily: 'Poppins Bold',
            fontSize: '0.875rem',
            lineHeight: '21px',
            letterSpacing: '0.92px',
            color: textColor,
        },
        subtitle1: {
            color: '#8A8A8A',
            fontFamily: 'Poppins',
            fontSize: '0.6875rem',
            letterSpacing: '0.92px',
            lineHeight: '20px'
        },
        body2: {
            color: textColor,
            fontSize: '12px',
            lineHeight: '18px'
        }
    }
})


const themeOverrides = createMuiTheme(
    {
        ...themeMain,
        overrides: {
            MuiButton: {
                root: {
                    cursor: 'pointer',
                    //height:'100%',
                    minWidth: '100px',
                    borderRadius: '25px'
                },
                textPrimary: {
                    color: 'white',
                },
                textSecondary: {
                    color: primaryColor,
                },
                outlined: {
                    border: '2px solid !important'
                },
            },
            MuiOutlinedInput :{
                notchedOutline: {
                    borderRadius: '100px'
                }
            },
            MuiTextField: {
                root: {
                    //backgroundColor: 'white',
                    //borderRadius: '5px',
                    //borderColor: '#CECECE'
                }
            },
            MuiTableCell: {
                root: {
                    paddingRight: '10px'
                }
            },
            MuiStepLabel:{
                label:{
                    marginTop: '5px !important',
                    fontSize: '14px'
                },
                active:{
                    fontFamily: 'Poppins Bold'
                },
            },
            MuiSelect: {
                root: {
                    paddingRight: '22px'
                }
            }
        }
    }
);

export const roundedCorners : CSSProperties = { 
    borderRadius: '15px',
    borderColor: primaryColor,
    borderWidth: '1px',
    borderStyle: 'solid'
}

export default themeOverrides;